<template>
    <div style="background: linear-gradient( 180deg, #FFF4DB 0%, #F7F7F7 100%);">
        <van-sticky>
            <van-nav-bar title="联系客服" left-arrow @click-left="onClickLeft" />
        </van-sticky>
        <div style="text-align: center;">
            <div style="margin-top: 33px;margin-bottom: 31px;">
                <img src="https://img.zhujiaxian.com/2026/01/fbf8ba63c6e14d0fadbdc0a6d2833d8f.png" style="width: 345px;height: 362px;" />
            </div>
            <div>
                <button @click="contactCustomerService">联系客服</button>
            </div>
        </div>
    </div>
</template>
<script>
import { GetUserInfo } from "@/https/http";
    export default {
        name: "Customerservice",
        data() {
            return {
                title:'',
                userInfo: {},
            }
        },
        created() {
            this.title = "联系客服";
            this.getloginData();
        },
        methods: {
              // 发送数据请求：登录注册
            getloginData() {
            GetUserInfo().then((res) => {
                console.log(res);
                this.userInfo = res.data
                // if (res.errno === 0) {
                //   console.log("登录成功");
                //   this.$toast.success("登录成功");
                //   localStorage.setItem("token", res.data.token);
                //   localStorage.setItem("userInfo", JSON.stringify(res.data.userInfo));
                //   this.ifShowModal = false; //不显示模态框
                //   this.ifLogined = true; // 显示用户名
                //   this.avatarSrc = res.data.userInfo.avatar; //头像
                //   this.username = res.data.userInfo.username;
                // }
            });
            },
            onClickLeft() {
                this.$router.back();
            },
            
            // 联系客服点击事件
            contactCustomerService() {
                // 使用从登录接口获取的用户信息构建客服URL
                const { userId, nickName, userMobile, pic } = this.userInfo;
                
                // 构建客服URL
                const customerServiceUrl = `https://kefu.zhujiaxian.com/index/index/home?visiter_id=${userId}&visiter_name=${nickName}_h5用户_${userMobile}&avatar=${pic}&groupid=0&special=2&theme=05202d&business_id=1&groupid=0&from=1`;
                
                // 打开客服页面
                window.location.href = customerServiceUrl;
            }
        }
    }
</script>
<style>

    button{
        width: 200px;
        height: 50px;
        background-color: #8FC31F;
        color: #fff;
        border: none;
        border-radius: 5px;
        font-size: 16px;
        cursor: pointer;
    }
</style>